import { useAuth } from '../../hooks/useAuth';
import { useFirebase } from '../../hooks/useFirebase';

import { queryGet } from '../tools';
import { useQuery } from '@tanstack/react-query';

export const useAppUser = () => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();

  const {
    data: appUser,
    isLoading: loading,
    isError: error
  } = useQuery({
    queryKey: ['user'],
    queryFn: async () => await queryGet(remoteConfig, '/user/me')(),
    enabled: !!user?.accessToken && !!remoteConfig
  });

  return {
    appUser,
    loading,
    error
  };
};
